
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

export default function AccessibilityStatement() {
  return (
    <main className="flex min-h-screen flex-col">
      <SEO 
        title="Accessibility Statement | WCAG Compliant Secondary Glazing Website" 
        description="Our commitment to making londonsecondaryglazing.co.uk accessible to everyone. WCAG 2.1 compliance information and accessibility features for users with disabilities."
        canonical="https://www.londonsecondaryglazing.co.uk/accessibility-statement"
        keywords="accessibility statement, WCAG compliance, website accessibility, inclusive design, disability access"
      />
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-primary">Accessibility Statement</h1>
          <div className="prose max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Commitment to Accessibility</h2>
              <p>SecondaryGlazing.London is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Conformance Status</h2>
              <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 level AA. These guidelines explain how to make web content more accessible for people with disabilities and more user-friendly for everyone.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Contact Us</h2>
              <p>If you encounter any accessibility barriers on our website, please contact us. We welcome your feedback and will consider all suggestions for improvement.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
